import GATSBY_COMPILED_MDX from "/opt/build/repo/src/daily_public_notes/2024-11-13.mdx";
import * as React from "react";
import BaseLayout from "../../components/BaseLayout";
import {Link} from "gatsby";
import {Helmet} from "react-helmet";
const BlogPost = _ref => {
  let {data, children} = _ref;
  const {title, date} = data.mdx.frontmatter;
  const formattedDate = new Date(date).toLocaleDateString();
  return React.createElement(React.Fragment, null, React.createElement(Helmet, null, React.createElement("title", null, title, " | Haruki Fujimaki"), React.createElement("meta", {
    name: "description",
    content: data.mdx.excerpt
  }), React.createElement("meta", {
    property: "og:title",
    content: title + " | Haruki Fujimaki"
  }), React.createElement("meta", {
    property: "og:description",
    content: data.mdx.excerpt
  }), React.createElement("meta", {
    property: "og:image",
    content: "https://makiart.dev/ogp.webp"
  }), React.createElement("meta", {
    name: "twitter:card",
    content: "summary"
  })), React.createElement(BaseLayout, null, React.createElement("article", {
    className: "max-w-2xl mx-auto"
  }, React.createElement("nav", {
    className: "mb-8"
  }, React.createElement(Link, {
    to: "/blogs",
    className: "text-sm text-tatami-brown/50 hover:text-tatami-gold transition-colors duration-200"
  }, "\u2190 \u8A18\u4E8B\u4E00\u89A7")), React.createElement("header", {
    className: "mb-10"
  }, React.createElement("p", {
    className: "text-xs text-tatami-brown/50 mb-3"
  }, formattedDate), React.createElement("h1", {
    className: "text-2xl sm:text-3xl font-heading font-bold text-tatami-ink leading-tight"
  }, title), React.createElement("div", {
    className: "h-[2px] w-12 bg-tatami-straw/60 mt-4"
  })), React.createElement("div", {
    className: "markdown"
  }, children), React.createElement("div", {
    className: "mt-16 mb-8"
  }, React.createElement("div", {
    className: "h-[2px] w-12 bg-tatami-straw/40 mb-6"
  }), React.createElement(Link, {
    to: "/blogs",
    className: "text-sm text-tatami-gold hover:text-tatami-straw transition-colors duration-200 font-heading"
  }, "\u2190 \u8A18\u4E8B\u4E00\u89A7\u306B\u623B\u308B")))));
};
const query = "2250018517";
BlogPost
export default function GatsbyMDXWrapper(props) {
  return React.createElement(BlogPost, props, React.createElement(GATSBY_COMPILED_MDX, props));
}
